<template>
  <div v-if="isReady" class="BaseImgVerif-container" :class="{'is-fullscreen': fullscreen, 'is-head-in': headIn}">
    <div class="my-head">
      <a class="my-refresh" @click="init"></a>
      <a class="my-close" @click="close"></a>
    </div>
    <div class="my-body">
      <div class="my-imgwrap">
        <img class="my-img-main" :src="mainImgForShow" />
        <img class="my-img-tick" :src="tickImgForShow" :style="{ left: xRatio + '%', width: `${blankRatioW}%`, top: yRatio + '%', }" />
        <p class="my-msg" :class="[msgObj.type]">{{ msgObj.text }}</p>
      </div>
      <div ref="handlerWrap" class="my-handlerwrap">
        <div class="my-handler-btn" :style="{ left: xRatio + '%', width: `${blankRatioW}%` }" @mousedown="onStart"></div>
        <div class="my-handler-track" :style="{ width: xRatio + '%' }"></div>
        <p>拖动左边滑块完成上方拼图</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BaseImgVerif',
  components: {
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: true
    },
    headIn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      base64Head: 'data:image/jpeg/png;base64,',
      mainImg: '',
      tickImg: '',
      xRatio: 0,
      yRatio: 0,
      // 大图规格
      cMainWidth: 268,
      cMainHeight: 150,
      // 小图规格
      cTickWidth: 35,
      cTickHeight: 25,
      wrapWidth: 0,
      startX: 0,
      endX: 0,
      isDraging: false,
      isReady: false,
      msgObj: {
        type: '',
        text: ''
      },
    }
  },
  computed: {
    blankRatioW() {
      return Math.round(10000 * this.cTickWidth / this.cMainWidth) / 100
    },
    uuid() {
      return this.$store.getters.vx_get_uuid
    },
    mainImgForShow() {
      return this.mainImg ? this.base64Head + this.mainImg : ''
    },
    tickImgForShow() {
      return this.tickImg ? this.base64Head + this.tickImg : ''
    },
    ...mapGetters([
    ]),
  },
  watch: {
  },
  created() {
    this.init()
  },
  mounted() {
  },
  methods: {
    init() {
      this.reset()
      this.$api.axiosGetImgVerif().then(res => {
        if (res.isOk) {
          this.$store.commit('vx_setData', {
            vx_uuid: res.data.uuid
          })
          if (!res.data.isShow) {
            this.$emit('success')
            this.close()
            return
          }
          this.cMainWidth = res.data.bigImageWidth || this.cMainWidth
          this.cMainHeight = res.data.bigImageHeight || this.cMainHeight
          this.cTickWidth = res.data.smallImageWidth || this.cTickWidth
          this.cTickHeight = res.data.smallImageHeight || this.cTickHeight
          this.mainImg = res.data.bigImage
          this.tickImg = res.data.smallImage
          this.yRatio = Math.round(10000 * res.data.yHeight / this.cMainHeight) / 100
          this.isReady = true
        } else {
          this.$message({
            type: 'error',
            message: '获取失败',
            center: true,
          })
        }
      }).catch(e => {
        console.error(e)
        this.$message({
          type: 'error',
          message: '网络连接失败',
          center: true,
        })
      }).then(() => {
        !this.isReady && this.close()
      })
    },
    onStart(e) {
      if (this.isDraging) return;
      this.isDraging = true
      this.startX = e.clientX
      this.wrapWidth = parseFloat(getComputedStyle(this.$refs.handlerWrap).width)
      document.addEventListener('mousemove', this.onMove)
      document.addEventListener('mouseup', this.onEnd)
    },
    onMove(e) {
      this.endX = e.clientX
      let v = 100 * (this.endX - this.startX) / this.wrapWidth
      let max = 100 - this.blankRatioW
      if (v > max) v = max
      else if (v < 0) v = 0
      this.xRatio = v
    },
    onEnd() {
      document.removeEventListener('mousemove', this.onMove)
      document.removeEventListener('mouseup', this.onEnd)
      let v = Math.round(this.cMainWidth * this.xRatio / 100)
      console.log(v)
      this.doCheck(v)
    },
    doCheck(v) {
      this.$api.axiosCheckImgVerif({
        uuid: this.uuid,
        moveLength: v
      }).then(res => {
        if (res.data) {
          this.msgObj = {
            type: 'success',
            text: '验证成功'
          }
          this.$emit('success')
          this.close()
        } else {
          this.msgObj = {
            type: 'error',
            text: '验证失败' // res.msg || (res.message || {}).title || '验证失败',
          }
          this.reset()
        }
      }).catch(e => {
        console.error(e)
        this.$message({
          type: 'error',
          message: '网络连接失败',
          center: true,
        })
        this.msgObj = {
          type: 'error',
          text: '网络连接失败'
        }
        this.reset()
      }).then(() => {
        setTimeout(() => this.msgObj.type = '', 1500)
      })
    },
    reset() {
      this.xRatio = 0
      this.isDraging = false
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.BaseImgVerif-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 20px;
  background: #fff;
  z-index: 1999;
  box-sizing: border-box;
  user-select: none;
  -webkit-app-region: drag;
  &.is-fullscreen {
    position: fixed;
    left: 50%;
    top: 50%;
    width: 400px;
    height: 370px;
    border: solid 1px #eee;
    transform: translate(-50%, -75%);
  }
  &.is-head-in .my-head {
    position: relative;
    margin-bottom: -30px;
    z-index: 9;
  }
}

.my-body {
  -webkit-app-region: no-drag;
}

.my-head {
  margin-bottom: 10px;
  text-align: right;
  a {
    display: inline-block;
    width: 24px;
    height: 24px;
    background-size: 100%;
    -webkit-app-region: no-drag;
    &:hover {
      opacity: .5;
    }
  }
}

.my-imgwrap {
  position: relative;
  font-size: 0;
  p {
    padding-left: .5em;
    font-size: 14px;
  }
}

.my-img-main {
  width: 100%;
}

.my-img-tick {
  position: absolute;
  left: 0;
}

.my-handlerwrap {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  margin-top: 20px;
  border: 1px solid #E2E3E7;
  border-radius: 4px;
  background: #F8F9FB;
  p {
    margin-left: 40px;
  }
}

.my-handler-btn {
  position: absolute;
  left: 0;
  top: 0;
  // width: 50px;
  height: 100%;
  background: #4b85ff;
  // border: 1px solid #E2E3E7;
  border-radius: 4px;
  box-shadow: 0 0 5px 0 rgba(0,0,0,0.20);
  z-index: 9;
  cursor: move;
}

.my-handler-track {
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 100%;
  z-index: 5;
  background: rgba(#4b85ff, .5);
}

.my-refresh {
  background: url(~@/assets/refresh.png) no-repeat;
}

.my-close {
  background: url(~@/assets/close_4b.png) no-repeat;
}

.my-msg {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  transition: all .3s;
  display: flex;
  align-items: center;
  height: 20px;
  color: #fff;
  opacity: 0;
  &.success {
    opacity: 1;
    background: rgba(green, .5);
  }
  &.error {
    opacity: 1;
    background: rgba(red, .5);
  }
}
</style>
